<template>
  <div class="d-flex flex-column align-center justify-center">
    <div v-if="question.text" class="question-text">
      {{ question.text }}
    </div>
    <v-slider
      v-model="answer"
      :thumb-size="24"
      :min="question.minValue"
      :max="maxValue"
      :readonly="maxValue === 0"
      :tick-size="isMobile ? 2 : 3"
      step="1"
      ticks="always"
      thumb-label="always"
      hide-details
      class="question-slider-el mt-5"
      @change="directSelect"
    >
      <template v-slot:append>
        <v-text-field
          v-model="customInputValue"
          :readonly="maxValue === 0"
          class="mt-0 pt-0 custom-input"
          type="number"
          hide-details
          dense
          filled
          rounded
          solo
          flat
          style="width: 35px"
          @input="customInput"
        />
      </template>
    </v-slider>
  </div>
</template>

<script>
export default {
  name: 'SliderQuestion',
  props: {
    question: {
      type: Object,
      required: true
    },
    parentAnswer: {
      type: Object,
      default: null
    },
    currentAnswer: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      answer: this.question.minValue,
      customInputValue: this.question.minValue
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    },
    maxValue() {
      if (!this.parentAnswer) {
        return this.question.maxValue;
      }
      return parseInt(this.parentAnswer.value) - 18;
    }
  },
  watch: {
    parentAnswer(newVal) {
      if (newVal && parseInt(this.answer) > (parseInt(newVal.value) - 18)) {
        this.answer = 0;
        this.customInputValue = 0;
        this.selectAnswer();
      }
    }
  },
  mounted() {
    this.answer = this.question.minValue;
    this.customInputValue = this.question.minValue;
    this.selectAnswer();
  },
  methods: {
    customInput(input) {
      console.log(input);
      if (input <= this.maxValue && input >= this.question.minValue) {
        this.customInputValue = input;
        this.answer = input;
        this.selectAnswer();
      } else {
        this.customInputValue = this.customInputValue > this.maxValue ? this.maxValue : this.question.minValue;
        this.answer = this.customInputValue;
        this.selectAnswer();
      }
    },
    directSelect() {
      this.customInputValue = this.answer;
      this.selectAnswer();
    },
    selectAnswer() {
      this.$emit('selectAnswer', {
        text: parseInt(this.answer),
        value: parseInt(this.answer),
        questionId: this.question.id,
        questionText: this.question.text
      });
    }
  }
};
</script>

<style scoped>
.question-text {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}
.question-slider-el {
  width: 90%;
  align-items: center !important;
}
.custom-input {
  border-radius: 4px;
  width: 355px;
}
.custom-input ::v-deep input {
  text-transform: uppercase;
  border: none;
}
.custom-input ::v-deep .v-input__slot {
  padding: 0 8px !important;
}
</style>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0 !important;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield !important;
}
</style>
